import { classnames } from '@tailwindcss-classnames';

export const heading = classnames('h4', 'mb-8');

export const formWrapper = classnames('flex', 'gap-x-4');

export const buttonWrapper = classnames('flex', 'justify-center', 'mt-6');
export const contactButton = classnames('w-auto');
